import { createReducer, on } from '@ngrx/store';
import * as TransferActions from './transfers.actions';
import { Transfer } from './transfers.models';

// -----------------------------------------------------------------------------------------------------
// @ States
// -----------------------------------------------------------------------------------------------------

export interface TransfersState {
    transfers: Transfer[];
    transfer: Transfer | null;
    isLoading: boolean;
    error: string | null;
}

// -----------------------------------------------------------------------------------------------------
// @ Initial States
// -----------------------------------------------------------------------------------------------------

export const initialTransfersState: TransfersState = {
    transfers: [],
    transfer: null,
    isLoading: false,
    error: null,
};

// -----------------------------------------------------------------------------------------------------
// @ Reducers
// -----------------------------------------------------------------------------------------------------

// Transfers Reducer
export const transfersReducer = createReducer(
    initialTransfersState,

    // On Load Transfers
    on(TransferActions.loadTransfers, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(TransferActions.loadTransfersSuccess, (state, { transfers }) => ({
        ...state,
        isLoading: false,
        transfers: transfers,
    })),
    on(TransferActions.loadTransfersFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Load Single Transfer
    // on(TransferActions.loadTransfer, (state) => ({
    //     ...state,
    //     isLoading: true,
    // })),
    // on(TransferActions.loadTransferSuccess, (state, { transfer }) => ({
    //     ...state,
    //     isLoading: false,
    //     transfer: transfer,
    // })),
    // on(TransferActions.loadTransferFailure, (state, { error }) => ({
    //     ...state,
    //     isLoading: false,
    //     error: error,
    // })),

    // On Create
    on(TransferActions.createTransfer, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(TransferActions.createTransferSuccess, (state, { transfer }) => ({
        ...state,
        isLoading: false,
        transfers: [...(state.transfers || []), transfer],
    })),
    on(TransferActions.createTransferFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))

    // On Update
    //   on(TransferActions.updateTransfer, (state) => ({
    //     ...state,
    //     isLoading: true,
    //   })),
    //   on(TransferActions.updateTransferSuccess, (state, { transfer }) => ({
    //     ...state,
    //     isLoading: false,
    //     transfers: state.transfers.map((r) => (r.id === transfer.id ? transfer : r)),
    //   })),
    //   on(TransferActions.updateTransferFailure, (state, { error }) => ({
    //     ...state,
    //     isLoading: false,
    //     error: error,
    //   })),

    // On Delete
    //   on(TransferActions.deleteTransfer, (state) => ({
    //     ...state,
    //     isLoading: true,
    //   })),
    //   on(TransferActions.deleteTransferSuccess, (state, { id }) => ({
    //     ...state,
    //     isLoading: false,
    //     transfers: state.transfers.filter((r) => r.id !== id),
    //   })),
    //   on(TransferActions.deleteTransferFailure, (state, { error }) => ({
    //     ...state,
    //     isLoading: false,
    //     error: error,
    //   }))
);
